import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOrdersDownloadParams } from '~/types/delivery-agency.types';

const usePostOrdersDownload = () => {
  const { runDownloadAsync } = useAsyncHandler();

  const postOrdersDownload = useAPI<TypePostOrdersDownloadParams>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_ORDERS_EXCEL_DOWNLOAD,
    method: 'post',
    responseType: 'blob',
  });

  const requestOrdersDownload = async (
    params: TypePostOrdersDownloadParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) =>
    runDownloadAsync(() => postOrdersDownload({ params }), {
      onSuccess,
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });

  return { requestOrdersDownload };
};

export default usePostOrdersDownload;
